import { BadgeProps } from '../base/badge'

export const contactTypes: Record<string, { name: string, color: BadgeProps['color'] }> = {
  front_office: { name: 'Front Office', color: 'red' },
  facilities: { name: 'Facilities', color: 'blue' },
  security: { name: 'Security', color: 'yellow' },
  other: { name: 'Other', color: 'purple' },
}
